// extracted by mini-css-extract-plugin
export default {"default":"Checkbox_default__Kv1Xt"};